import { render, staticRenderFns } from "./ModelEditor.vue?vue&type=template&id=6674208b&scoped=true&"
import script from "./ModelEditor.vue?vue&type=script&lang=ts&"
export * from "./ModelEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ModelEditor.vue?vue&type=style&index=0&id=6674208b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6674208b",
  null
  
)

export default component.exports